import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import Routes from 'routes';
import { StorageService } from '@dfl/react-security';
import { CustomStorageService } from './services/CustomStorageService';

function App () {
  StorageService.setup(new CustomStorageService());

  return <Routes />;
}

export default App;
